import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about-us-content-wrap" }
const _hoisted_2 = { class: "about-us-block" }
const _hoisted_3 = { class: "about-us-block-text" }

import {about, useLocalizationStore} from "@/shared";
import {AboutUsContentBlock, BlockPreviewData, WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'about-us-content',
  setup(__props) {

const {translate} = useLocalizationStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BlockPreviewData), {
        "body-title": _unref(translate)('about_us_content_first_title'),
        image: _unref(about)
      }, {
        "header-title": _withCtx(() => [
          _createVNode(_unref(WrapTitle), {
            text: _unref(translate)('about_us_span'),
            class: "preview-data-header-title-about-us-block margin-l",
            weight: "700",
            size: "regular"
          }, null, 8, ["text"])
        ]),
        content: _withCtx(() => [
          _createVNode(_unref(AboutUsContentBlock))
        ]),
        _: 1
      }, 8, ["body-title", "image"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('contact_us_footer_text'),
          class: "preview-data-about-us-block-text",
          size: "regular",
          weight: "800"
        }, null, 8, ["text"])
      ])
    ])
  ]))
}
}

})